export const getMatchingMimeTypes = (entityTypeMimeTypes: string, featureMimeTypes: string) => {
  if (featureMimeTypes.split(',').every((value) => entityTypeMimeTypes.split(',').includes(value))) {
    return featureMimeTypes.split(',');
  } else {
    return featureMimeTypes.split(',').filter((value) => entityTypeMimeTypes.split(',').includes(value));
  }
};